import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { scrollToTop } from '../utils/scrollUtils';

/**
 * Custom hook to scroll to top when the route changes
 * This ensures that when a user navigates to a new page, they start at the top
 */
export const useScrollToTop = () => {
  const { pathname } = useLocation();

  useEffect(() => {
    // Scroll to top with a small delay to ensure DOM is ready
    setTimeout(() => {
      scrollToTop('instant');
    }, 0);
  }, [pathname]);
};